import { fetched, error, fetching } from './rules.types';

export const  fetchRules =() => ({ type: fetching })
export const  fetchedRules =(payload) => ({ type: fetched, payload })
export const  errorFetchingRules =(msg) => ({ type: error, error: msg })
